import { useState } from "react";
import Logo from "@/components/Logo";
import { Phone, Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const links = [
  { href: "#benefits", label: "المزايا" },
  { href: "#ingredients", label: "المكوّنات" },
  { href: "#results", label: "قبل وبعد" },
  { href: "#faq", label: "الأسئلة" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-emerald-900/10 bg-[#FBF9F4]/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Logo />
        <nav className="hidden items-center gap-7 lg:flex" data-testid="main-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}-link`}
              className="text-sm font-medium text-[#566B63] transition-colors duration-300 hover:text-[#1F7A52]"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#order"
            data-testid="header-order-button"
            className="whitespace-nowrap rounded-full bg-[#0F1E19] px-4 py-2.5 text-xs font-bold text-[#FBF9F4] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#1F7A52] hover:shadow-lg hover:shadow-emerald-900/20 sm:px-5 sm:text-sm"
          >
            اطلب الآن · 129 درهم
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-button"
            aria-label={open ? "إغلاق القائمة" : "فتح القائمة"}
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-xl border border-emerald-900/15 text-[#0F1E19] transition-colors hover:bg-[#E8F5EF] lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="overflow-hidden border-t border-emerald-900/10 bg-[#FBF9F4] lg:hidden"
            data-testid="mobile-nav"
          >
            <div className="space-y-1 px-4 py-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`mobile-nav-${l.href.slice(1)}-link`}
                  onClick={() => setOpen(false)}
                  className="block rounded-xl px-4 py-3.5 text-base font-bold text-[#0F1E19] transition-colors hover:bg-[#E8F5EF] hover:text-[#1F7A52]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="tel:0689067964"
                data-testid="mobile-nav-phone-link"
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 rounded-xl px-4 py-3.5 text-base font-bold text-[#1F7A52] transition-colors hover:bg-[#E8F5EF]"
              >
                <Phone className="h-4 w-4" />
                <span dir="ltr">0689067964</span>
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
